import { Link } from 'react-router-dom';
import { categories } from '@/mocks/data';

export default function Footer() {
  return (
    <footer className="bg-secondary-50 border-t border-secondary-200/60">
      <div className="px-4 md:px-6 py-14">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <h3 className="font-heading text-lg text-foreground-900 mb-4">奶妈动漫</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                母乳哺育与动漫文化融合平台，汇聚原创作品、角色设定、同人创作及育儿知识科普。
              </p>
            </div>

            <div>
              <h4 className="font-heading text-base text-foreground-900 mb-4">内容分类</h4>
              <div className="flex flex-col gap-2">
                {categories.slice(0, 4).map((cat) => (
                  <Link
                    key={cat.id}
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                ))}
              </div>
            </div>

            <div>
              <h4 className="font-heading text-base text-foreground-900 mb-4">更多分类</h4>
              <div className="flex flex-col gap-2">
                {categories.slice(4).map((cat) => (
                  <Link
                    key={cat.id}
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                ))}
                <Link
                  to="/about"
                  className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap"
                >
                  关于我们
                </Link>
              </div>
            </div>

            <div>
              <h4 className="font-heading text-base text-foreground-900 mb-4">关注我们</h4>
              <p className="text-sm text-foreground-600 mb-3">hello@naimadongman.com</p>
              <div className="flex items-center gap-4">
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-100 text-foreground-600 hover:bg-primary-500 hover:text-background-50 transition-colors" aria-label="微博">
                  <i className="ri-weibo-line text-lg"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-100 text-foreground-600 hover:bg-primary-500 hover:text-background-50 transition-colors" aria-label="微信">
                  <i className="ri-wechat-line text-lg"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-100 text-foreground-600 hover:bg-primary-500 hover:text-background-50 transition-colors" aria-label="B站">
                  <i className="ri-bilibili-line text-lg"></i>
                </a>
              </div>
            </div>
          </div>

          <div className="mt-10 pt-6 border-t border-secondary-200/60 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-foreground-500">
              &copy; 2024-2026 奶妈动漫 版权所有
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap">隐私政策</a>
              <a href="#" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap">用户协议</a>
              <a href="#" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap">联系我们</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}